// components/About.js
import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section fade-in-section">
      <div className="container">
        <h2 className="section-title">About LeadVala</h2>
        
        <div className="about-grid">
          <div className="about-content">
            <p className="about-text">
              LeadVala is a next-generation, AI-powered lead generation company founded in 2024 
              with the mission to revolutionize how businesses acquire new customers. Based in 
              Ahmedabad, India, we are committed to delivering only the highest quality, verified, 
              and conversion-focused leads across various industries.
            </p>
            
            <p className="about-text">
              We are not just a lead provider. LeadVala is a trusted growth partner for businesses 
              that want to move beyond random, unqualified inquiries and instead focus on verified 
              customer interest. From small local businesses to fast-scaling service brands, our 
              platform is built to empower all.
            </p>

            <p className="about-text">
              At LeadVala, we believe lead generation should be transparent, affordable, and driven 
              by real results - not guesswork or vanity metrics. With a powerful combination of AI 
              tools, data analysis, and human verification, we ensure every lead you receive is 
              worth your time and investment.
            </p>

            <div className="founder-section">
              <h3 className="founder-title">Our Founder</h3>
              <div className="founder-card">
                <div className="founder-image">
                  <div className="founder-placeholder">PS</div>
                </div>
                <div className="founder-info">
                  <h4 className="founder-name">Prakhar Soni</h4>
                  <p className="founder-role">Founder & Managing Director</p>
                  <p className="founder-bio">
                    A visionary entrepreneur and sales strategist, Prakhar has dedicated his career 
                    to simplifying lead generation through the power of technology. His mission is to 
                    help small and mid-sized businesses grow faster by providing high-quality, 
                    conversion-ready leads. Under his leadership, LeadVala is setting new standards 
                    for trust, performance, and affordability in the lead generation space.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-visual">
            <div className="feature-card" style={{animationDelay: '0s'}}>
              <div className="feature-icon">🚀</div>
              <h4>AI-Powered</h4>
              <p>Advanced algorithms identify high-intent prospects with precision</p>
            </div>
            
            <div className="feature-card" style={{animationDelay: '0.2s'}}>
              <div className="feature-icon">✓</div>
              <h4>Human Verified</h4>
              <p>Every lead double-checked by our expert verification team</p>
            </div>
            
            <div className="feature-card" style={{animationDelay: '0.4s'}}>
              <div className="feature-icon">📈</div>
              <h4>Results Driven</h4>
              <p>Focus on ROI and conversion rates that matter to your business</p>
            </div>

            <div className="feature-card" style={{animationDelay: '0.6s'}}>
              <div className="feature-icon">🎯</div>
              <h4>Industry Specific</h4>
              <p>Tailored lead generation for your specific industry needs</p>
            </div>
          </div>
        </div>

        <div className="about-stats">
          <div className="about-stat">
            <div className="stat-value">2024</div>
            <div className="stat-desc">Founded</div>
          </div>
          <div className="about-stat">
            <div className="stat-value">7-Layer</div>
            <div className="stat-desc">Verification System</div>
          </div>
          <div className="about-stat">
            <div className="stat-value">24/7</div>
            <div className="stat-desc">Lead Delivery</div>
          </div>
          <div className="about-stat">
            <div className="stat-value">100%</div>
            <div className="stat-desc">Verified Leads</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;